<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <el-table
      ref="listTable"
      :data="list"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%"
      :height="getTableHeight(165)"
      size="small"
      fit
      row-key="Id"
    >
      <el-table-column label="对象">
        <template slot-scope="scope">
          {{ scope.row.Mode == 2 ? field(scope.row.ShopConfig.Name) : "全体" }}
        </template>
      </el-table-column>
      <el-table-column prop="Mode" label="模式" width="100">
        <template slot-scope="scope">
          {{ $t("ShopDateEvent.ModeList." + scope.row.Mode) }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('TypeName')" width="100">
        <template slot-scope="scope">
          {{ $t("ShopDateEvent.TypeList." + scope.row.Type) }}
        </template>
      </el-table-column>
      <el-table-column label="日期时间" width="200">
        <template slot-scope="scope">
          {{ formatDate(scope.row.StartDate) }} ~
          {{ formatDate(scope.row.EndDate) }}
        </template>
      </el-table-column>
      <el-table-column label="值" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.Type == 3" class="text_red">{{
            scope.row.Value
          }}</span>
          <span v-if="scope.row.Type == 2">{{ scope.row.Content }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Enabled" label="状态" width="65">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.Enabled ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.Enabled ? "正常" : "禁用" }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('Remark')"
        prop="Remark"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column :label="$t('DateTime')" prop="DateTime" width="130">
        <template slot-scope="scope">{{
          formatDateTime(scope.row.DateTime)
        }}</template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="total,prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="addForm" label-width="150px" ref="addForm" size="small">
        <el-form-item
          label="模式"
          prop="Mode"
          :rules="{ required: true, message: $t('pleaseChoose') + '模式' }"
        >
          <el-select v-model="addForm.Mode" placeholder="Select Mode">
            <el-option
              v-for="(value, key) in $t('ShopDateEvent.ModeList')"
              :key="key"
              :label="value"
              :value="parseInt(key)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="类型"
          prop="Type"
          :rules="{ required: true, message: $t('pleaseChoose') + '类型' }"
        >
          <el-select v-model="addForm.Type" placeholder="Select Type">
            <el-option
              v-for="(value, key) in $t('ShopDateEvent.TypeList')"
              :key="key"
              :label="value"
              :value="parseInt(key)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="内容"
          prop="Content"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + '内容',
          }"
          v-if="addForm.Type == 2"
        >
          <el-input
            type="textarea"
            :autosize="{ minRows: 1 }"
            v-model="addForm.Content"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('Amount')"
          prop="Amount"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + $t('Amount'),
          }"
          v-if="addForm.Type == 3"
        >
          <el-input-number
            v-model.number="addForm.Value"
            :precision="2"
            :step="0.1"
            :max="9999"
            style="width: 195px"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          label="商户"
          prop="ShopIds"
          :rules="{ required: true, message: $t('pleaseEnter') + '商户' }"
          v-if="addForm.Mode == 2"
        >
          <el-select
            v-model="addForm.ShopIds"
            filterable
            remote
            clearable
            placeholder="请输入关键词"
            :remote-method="shopRemoteMethod"
            :loading="selectShoploading"
            multiple
            style="width: 300px"
          >
            <el-option
              v-for="item in shopList"
              :key="item.Id"
              :label="field(item.Name)"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('StartDateTime')"
          prop="StartDate"
          :rules="{
            required: true,
            message: $t('pleaseChoose') + $t('StartDateTime'),
          }"
        >
          <el-date-picker
            :picker-options="pickerOptionsAddStart"
            v-model="addForm.StartDate"
            type="date"
            placeholder="Select Date"
            :editable="false"
            @change="addStartDateChange"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          :label="$t('EndDateTime')"
          prop="EndDate"
          :rules="{
            required: true,
            message: $t('pleaseChoose') + $t('EndDateTime'),
          }"
        >
          <el-date-picker
            :picker-options="pickerOptionsAddEnd"
            v-model="addForm.EndDate"
            type="date"
            placeholder="Select Date"
            :editable="false"
            @change="addEndDateChange"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="内部备注">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2 }"
            v-model="addForm.Remark"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="addForm.Enabled"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--修改-->
    <el-dialog
      :title="$t('edit')"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form
        :model="editForm"
        label-width="150px"
        ref="editForm"
        size="small"
      >
        <el-form-item label="对象">
          {{ editForm.Mode == 2 ? field(editForm.ShopConfig.Name) : "全体" }}
        </el-form-item>
        <el-form-item
          label="类型"
          prop="Type"
          :rules="{ required: true, message: $t('pleaseChoose') + '类型' }"
        >
          <el-select v-model="editForm.Type" placeholder="Select Type">
            <el-option
              v-for="(value, key) in $t('ShopDateEvent.TypeList')"
              :key="key"
              :label="value"
              :value="parseInt(key)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="内容"
          prop="Content"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + '内容',
          }"
          v-if="editForm.Type == 2"
        >
          <el-input
            type="textarea"
            :autosize="{ minRows: 1 }"
            v-model="editForm.Content"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('Amount')"
          prop="Value"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + $t('Amount'),
          }"
          v-if="editForm.Type == 3"
        >
          <el-input-number
            v-model.number="editForm.Value"
            :precision="2"
            :step="0.1"
            :max="9999"
            style="width: 195px"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          :label="$t('StartDateTime')"
          prop="StartDate"
          :rules="{
            required: true,
            message: $t('pleaseChoose') + $t('StartDateTime'),
          }"
        >
          <el-date-picker
            :picker-options="pickerOptionsEditStart"
            v-model="editForm.StartDate"
            type="date"
            placeholder="Select Date"
            :editable="false"
            @change="upStartDateChange"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          :label="$t('EndDateTime')"
          prop="EndDate"
          :rules="{
            required: true,
            message: $t('pleaseChoose') + $t('EndDateTime'),
          }"
        >
          <el-date-picker
            :picker-options="pickerOptionsEditEnd"
            v-model="editForm.EndDate"
            type="date"
            placeholder="Select Date"
            :editable="false"
            @change="upEndDateChange"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="内部备注">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2 }"
            v-model="editForm.Remark"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="editForm.Enabled"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >{{ $t("submit") }}</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "util/date";
import {
  getShopDateEventList,
  removeShopDateEvent,
  editShopDateEvent,
  addShopDateEvent,
  getShopList,
} from "@/api/api";
import { getButtonList } from "@/promissionRouter";
export default {
  data() {
    return {
      filters: {
        Name: "",
      },
      buttonList: [],
      list: [],
      total: 0,
      page: 1,
      listLoading: false,
      currentRow: null,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      //编辑界面数据
      editForm: { Name: {} },
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      //新增界面数据
      addForm: {},
      shopList: [],
      selectShoploading: false,
      pickerOptionsAddStart: {
        disabledDate: (time) => {
          const endDateVal = new Date(this.addForm.EndDate).getTime();
          if (endDateVal) {
            return time.getTime() > endDateVal - 0;
          }
        },
      },
      pickerOptionsAddEnd: {
        disabledDate: (time) => {
          var newdate = new Date(this.addForm.StartDate);
          const beginDateVal = new Date(
            newdate.setDate(newdate.getDate() - 1)
          ).getTime();
          if (beginDateVal) {
            return time.getTime() < beginDateVal - 0;
          }
        },
      },
      pickerOptionsEditStart: {
        disabledDate: (time) => {
          const endDateVal = new Date(this.editForm.EndDate).getTime();
          if (endDateVal) {
            return time.getTime() > endDateVal - 0;
          }
        },
      },
      pickerOptionsEditEnd: {
        disabledDate: (time) => {
          var newdate = new Date(this.editForm.StartDate);
          const beginDateVal = new Date(
            newdate.setDate(newdate.getDate() - 1)
          ).getTime();
          if (beginDateVal) {
            return time.getTime() < beginDateVal - 0;
          }
        },
      },
    };
  },
  methods: {
    shopRemoteMethod(query) {
      if (query !== "") {
        let para = {
          key: query,
        };
        this.selectShoploading = true;
        getShopList(para).then((res) => {
          this.shopList = res.data.response.data;
          this.selectShoploading = false;
        });
      } else {
        this.shopList = [];
      }
    },
    formatDate: function (val) {
      return util.formatDate.format(new Date(val), "yyyy-MM-dd");
    },
    addStartDateChange(val) {
      this.addForm.StartDate = this.formatDate(val);
    },
    upStartDateChange(val) {
      this.editForm.StartDate = this.formatDate(val);
    },
    addEndDateChange(val) {
      this.addForm.EndDate = this.formatDate(val);
    },
    upEndDateChange(val) {
      this.editForm.EndDate = this.formatDate(val);
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        Name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    formatDateTime: function (val) {
      return util.formatDate.format(new Date(val), "yyyy-MM-dd hh:mm");
    },
    searchList() {
      this.page = 1;
      this.getList();
    },
    //获取列表
    getList() {
      let _this = this;

      let para = {
        key: this.filters.Name,
        page: this.page,
      };
      this.listLoading = true;
      getShopDateEventList(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.list = res.data.response.data;
        this.listLoading = false;
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: this.$t("selectRow"),
          type: "error",
        });

        return;
      }
      this.$confirm(this.$t("deletePrompt"), this.$t("prompt"), {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          let para = { id: row.Id };
          removeShopDateEvent(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: this.$t("deleteSuccess"),
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getList();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: this.$t("selectRow"),
          type: "error",
        });

        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, this.clone(row));
    },

    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.editLoading = true;
              //NProgress.start();
              let para = Object.assign({}, this.editForm);

              editShopDateEvent(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.editLoading = false;
                  return;
                }
                if (res.data.success) {
                  this.editLoading = false;
                  //NProgress.done();
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["editForm"].resetFields();
                  this.editFormVisible = false;
                  this.$refs.listTable.setCurrentRow();
                  this.getList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    }, 
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        ShopIds: [],
        Value: 0,
        StartDate: "",
        EndDate: "",
        Enabled: false,
      };
    },
    //新增
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.addLoading = true;
              //NProgress.start();
              let para = Object.assign({}, this.addForm);
              para.IsDeleted = false;

              addShopDateEvent(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.addLoading = false;
                  return;
                }

                if (res.data.success) {
                  this.addLoading = false;
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["addForm"].resetFields();
                  this.addFormVisible = false;
                  this.getList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
  },
  mounted() {
    this.getList();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>